import React from "react";
import "./DigiHero.css"; // Import CSS for styling

const FlexiImage = () => {
  return (
    <div className="digihero-container">
      <img
        src="assets/schemes/flexi.png"
        alt="Digi Hero"
        className="digihero-image"
      />
    </div>
  );
};

export default FlexiImage;
